import { searchLocations } from 'api/locations/searchLocation'
import { GenericSearch } from 'components/GenericSearch/GenericSearch'
import { LocationSearchResult } from 'components/Location/LocationCard/LocationSearchResult'
import { useCallback } from 'react'
import { Label } from 'theme-ui'
import { TeachingLocation } from 'types/location'

export type LocationSearchInputProps = {
  currLocations: string[]
  onLocationPicked: (id: string) => void
  countryCode?: string
  tabIndex?: number
  onError: (error: string) => void
}

export const LocationSearchInput = ({
  currLocations,
  onLocationPicked,
  countryCode,
  tabIndex,
  onError,
}: LocationSearchInputProps) => {
  const hiddenLocations = new Set(currLocations)
  const countryLocationSearch = useCallback(
    async ({ query }: { query: string }) =>
      await searchLocations({ query, countryCode }),
    [countryCode]
  )
  const handleItemSelected = ({ id }: TeachingLocation) => {
    onLocationPicked(id)
  }
  return (
    <>
      <Label
        htmlFor="LocationSearchInput"
        sx={{ fontWeight: 600, fontSize: 16 }}>
        Search for a location
      </Label>
      <GenericSearch
        id="LocationSearchInput"
        placeholder="Search by city or center name"
        limit={5}
        searchFunc={countryLocationSearch}
        onItemSelected={handleItemSelected}
        filterResults={(locations) =>
          locations.filter(({ id }) => !hiddenLocations.has(id))
        }
        ItemCard={LocationSearchResult}
        tabIndex={tabIndex}
        onError={onError}
      />
    </>
  )
}
